import { createFileRoute } from "@tanstack/react-router";
import { SiteRoute, siteSearch } from "@/components/sites/site-route";

// Una página de un sitio público (convex/sites/public.ts).
export const Route = createFileRoute("/_public/s/$slug/$page")({
  validateSearch: siteSearch,
  component: SitePage,
});

function SitePage() {
  const { slug, page } = Route.useParams();
  const { picks } = Route.useSearch();
  return <SiteRoute slug={slug} page={page} picks={picks} />;
}
